import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useSettingsUpdate = () => {
  return useMutation({
    mutationFn: (data) => api.settings.updateOpenApi(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить настройки OpenAPI',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Настройки успешно обновлены',
        type: 'success',
      })
    }
  })
}
